/* eslint-disable no-template-curly-in-string */

export const errorMessages = {
  YEAR_MISSING: 'Date of birth must include a year',
  YEAR_INVALID: 'Year must include 4 numbers',
  MONTH_MISSING: 'Date of birth must include a month',
  MONTH_INVALID: 'Enter a valid date of birth, like 20 3 2004',
  DAY_MISSING: 'Date of birth must include a day',
  DAY_INVALID: 'Enter a valid date of birth, like 20 3 2004',
  DATE_OF_BIRTH_MISSING: 'Enter your date of birth',
  DATE_OF_BIRTH_IN_FUTURE: 'Date of birth must be in the past',
  DATE_OF_BIRTH_INVALID: 'Enter a valid date of birth, like 20 3 2004',
  REQUIRED: '${label} is a required field',
  CHECKBOXES_REQUIRED:
    'Select at least one option from the "${label}" checkboxes',
  CHECKBOX_REQUIRED: 'The "${label}" checkbox is required',
  RADIOS_REQUIRED: 'Select one of the "${label}" options',
  EMAIL_INVALID: `This email address isn't valid. Try again in the format name@example.com`,
  EMAIL_REQUIRED: 'Enter an email address, like name@example.com',
  PHONE_NUMBER_REQUIRED:
    'Enter a phone number, like 01632960001, 07700900982 or +448081570192',
  PHONE_NUMBER_INVALID:
    'Enter a valid phone number, like 01632960001, 07700900982 or +448081570192',
  PHONE_NUMBER_TOO_SHORT:
    'Enter a valid phone number with at least 10 digits, like 01632960001, 07700900982 or +448081570192',
  PHONE_NUMBER_INTERNATIONAL_REQUIRED: `Enter a phone number`,
  PHONE_NUMBER_INTERNATIONAL_INVALID: `Enter a phone number`,
  ADDRESS_INVALID: 'This is not a valid address',
  ADDRESS_REQUIRED: 'Enter your address',
  CITY_REQUIRED: 'Enter your town or city',
  COUNTRY_REQUIRED: 'Enter your country',
  POSTCODE_REQUIRED: 'Enter a valid UK postcode',
  POSTCODE_INVALID: 'Enter a valid UK postcode',
  POSTCODE_REQUIRED_INTERNATIONAL: 'Enter a valid postal code',
  FILE_UPLOAD_REQUIRED: 'Upload one or more files',
  AUTO_SUGGEST_REQUIRED: 'The ${label} field is required',
  AUTO_SUGGEST_INVALID:
    'The ${label} field must be one of the suggested options',
  NUMBER_REQUIRED: 'Please enter a number',
};

export const labels = {
  DOB_DAY: 'Day',
  DOB_MONTH: 'Month',
  DOB_YEAR: 'Year',
  CONSENT_POST:
    "We'll also send you postal updates on what's happening. Prefer not to receive these? Just tick here to opt out",
  CONSENT_EMAIL: 'Email',
  CONSENT_TEXT: 'Text',
  CONSENT_PHONE: 'Phone',
};

export const consentStatement = `Want to be kept updated on our work, campaigns, fundraising
  activities, events, volunteering opportunities, and products and
  services? Please tick below:`;
